import {
    PinturaEditor,
    PinturaEditorModal,
    PinturaEditorOverlay,
} from "@pqina/vue-pintura";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component("PinturaEditor", PinturaEditor);
    nuxtApp.vueApp.component("PinturaEditorModal", PinturaEditorModal);
    nuxtApp.vueApp.component("PinturaEditorOverlay", PinturaEditorOverlay);
});
